import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { styleCss } from "components/layout/utils";

export interface IBlockProps {
  height?: string;
  minHeight?: string;
  maxHeight?: string;
  width?: string;
  minWidth?: string;
  maxWidth?: string;
  lineHeight?: string;
  margin?: string;
  marginTop?: string;
  marginBottom?: string;
  marginLeft?: string;
  marginRight?: string;
  marginH?: string;
  marginV?: string;
  padding?: string;
  paddingTop?: string;
  paddingBottom?: string;
  paddingLeft?: string;
  paddingRight?: string;
  paddingH?: string;
  paddingV?: string;
  bg?: string;
  border?: string;
  borderBottom?: string;
  borderTop?: string;
  borderRadius?: string;
  relative?: boolean;
  clickable?: boolean;
  boxSizing?: "border-box" | "content-box";
  overflow?: "auto" | "hidden" | "scroll" | "visible";
  overflowX?: "auto" | "hidden" | "scroll" | "visible";
  overflowY?: "auto" | "hidden" | "scroll" | "visible";
  flex?: number | string;
  flexGrow?: number | string;
  flexShrink?: number | string;
  flexBasis?: string;
  outline?: string;
  gridColumn?: string;
  gridRow?: string;
  gridArea?: string;
  boxShadow?: string;
}

const Block = styled.div<IBlockProps>`
  display: block;
  ${styleCss("height")};
  ${styleCss("minHeight")};
  ${styleCss("maxHeight")};
  ${styleCss("width")};
  ${styleCss("minWidth")};
  ${styleCss("maxWidth")};
  ${styleCss("lineHeight")};

  ${styleCss("margin")};
  ${styleCss("marginTop")};
  ${styleCss("marginBottom")};
  ${styleCss("marginLeft")};
  ${styleCss("marginRight")};
  ${styleCss("marginH", "margin-left")};
  ${styleCss("marginH", "margin-right")};
  ${styleCss("marginV", "margin-top")};
  ${styleCss("marginV", "margin-bottom")};

  ${styleCss("padding")};
  ${styleCss("paddingTop")};
  ${styleCss("paddingBottom")};
  ${styleCss("paddingLeft")};
  ${styleCss("paddingRight")};
  ${styleCss("paddingH", "padding-left")};
  ${styleCss("paddingH", "padding-right")};
  ${styleCss("paddingV", "padding-top")};
  ${styleCss("paddingV", "padding-bottom")};

  ${styleCss("bg", "background")};
  ${styleCss("border")};
  ${styleCss("borderRadius")};
  ${styleCss("borderBottom")};
  ${styleCss("borderTop")};

  ${styleCss("outline")};

  ${styleCss("overflow")};
  ${styleCss("overflowX")};
  ${styleCss("overflowY")};
  ${styleCss("boxSizing")};
  ${styleCss("flex")};
  ${styleCss("flexGrow")};
  ${styleCss("flexShrink")};
  ${styleCss("flexBasis")};

  ${styleCss("gridColumn")};
  ${styleCss("gridRow")};
  ${styleCss("gridArea")};
  ${styleCss("boxShadow")};

  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) =>
      props.relative &&
      css`
        position: relative;
      `
  };

  ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) =>
      props.clickable &&
      css`
        &:hover {
          cursor: pointer;
        }
      `
  };
`;

export default Block;
